export const compare = (a, b) => {
  return a.displayOrder - b.displayOrder;
};
